import {
    GET_LIST_SURVEY_BY_CLIENT_SUCCESS,
    GET_SURVEY_BY_CLIENT_SUCCESS,
    GET_SURVEY,
	SHOW_REVIEWS_CHANGE,
  } from '../actions/ActionClient'

const INITIAL_STATE = {
	ListSurveysClientById: [],
	SurveyByIdClient: [],
	Survey: {},
	ShowReviews: false
}

/**
 * It returns a new state object based on the action type.
 * @param [state] - The current state of the store.
 * @param [action] - {type: "GET_LIST_SURVEY_BY_CLIENT_SUCCESS", content: {surveys: [{id: 1, name:
 * "Survey 1"}, {id: 2, name: "Survey 2"}]}}
 * @returns {
 *   "survey": {
 *     "id": "1",
 *     "name": "Survey 1",
 *     "description": "Survey 1 description",
 *     "questions": [
 *       {
 *         "id": "1",
 *         "question": "Question 1",
 *         "type": "text",
 *         "options": []
 */
export const reduceClient = (state = INITIAL_STATE, action={}) => {
	switch(action.type) { 
		case GET_LIST_SURVEY_BY_CLIENT_SUCCESS: 
			return {
				...state,
				...action.content
			};
        case GET_SURVEY_BY_CLIENT_SUCCESS: 
			return {
				...state,
				...action.content
			};
		case GET_SURVEY: 
			return {
				...state,
				...action.content
			};
		case SHOW_REVIEWS_CHANGE: 
			state.ShowReviews = !state.ShowReviews;
			return {
			  ...state 
			}
		default:
			return state;
	}
};